import React from 'react'
import { Segment } from 'semantic-ui-react';

function HankFooter() {
    return (
      <Segment vertical style={{ padding: '1em 0em' }}>
      Made with <span role="img" aria-label="heart">🖤🤍🤎</span> for HANK and his friends.
      </Segment>
    );
  }
export default HankFooter
